
import {timer as observableTimer,   Subscription, Observable } from 'rxjs';

import {tap, filter, map} from 'rxjs/operators';
import { Component, AfterContentChecked, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import {  UserProfileService, LoginService, UserProfileModel, ProductData, ProductRouteInfoService } from '../core';
import {environment} from '../../environments/environment';
import { IdleTimeoutService } from '../core/idle-timeout.service';
class dropdownMenuInfo{
  text:string;
  path?:string;
  disabled?:boolean;
  indent?:boolean;
}

@Component({
  selector: 'app-ri-header',
  templateUrl: './ri-header.component.html',
  styleUrls: ['./ri-header.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class RiHeaderComponent implements AfterContentChecked, OnInit, OnDestroy {
  backgroundCheck:Observable<number>;
  now: () => Date = () => new Date( Date.now());
  get showGDPRMsg(): boolean {
    return this.now() < environment.GDPRMsgEnd  && this.now() > environment.GDPRMsgStart ;
  };

  public userDisplayName: string = "";
  public customerName: string = "";
  public helpUrl:string = ""
  homeURL:string ="/main";

  public customerSelect: { text: string, value: number };
  //when passed to telerik data, bug handling none primitives was worked around using templates
  public customerSelectionList: Array<{ text: string, value: number }> = [];
  public customerDropdownPopupSettings = {height: 200, width: 250};
  public allowedToChangeCustomer: boolean = true; //changes this to fix issues for BT-9151

  public openBtnRateIntegrity: boolean;
  public openBtnAdministration: boolean;
  public openBtnReports: boolean;

  public enabledAdminAccess: Array<dropdownMenuInfo> =[];

  public enabledReports: Array<dropdownMenuInfo> = [
    {text: 'Rate Audit Summary', path:'reports/rate-audit-summary-report' },
    {text: 'GDS Usage', path: 'reports/gds-usage-report'}
  ]
  public enabledProducts: Array<ProductData> = [];
  public availableReports: Array<any> = [{text: 'GDS Usage Report'}];
  public reportIconClass =  "report-icon cvt-icon-contacts";

  reportsMapping: Array<ProductData>;
  subscriptions:Subscription[]=[];

  constructor(private userProfileService:UserProfileService
              ,private loginService:LoginService
              ,private router:Router
              ,private productRouteInfoService: ProductRouteInfoService
              ,private idleTimeoutSvc: IdleTimeoutService
              ) {
                this.helpUrl = environment.helpUrl;
              }
  ngOnInit(){
    let delay = 10 * (60 * 1000); //every ten minutes
    if(environment.backgroundCheck){
      this.backgroundCheck = observableTimer(delay, delay);
      var s1= this.backgroundCheck.subscribe(
        (x) =>{
          console.log("backgroundCheck " + x)
          this.userProfileService.IsUserLoggedIn()
            .subscribe(yes =>{
              if(!yes ){
                let logoutUrl = this.userProfileService.data.SSOPortalURL;
                if(logoutUrl){
                  window.location.assign(logoutUrl);
                }else{
                  this.router.navigate(['/login']);
                }
              }
            },err =>{console.log(err)});
        }
      )
      this.subscriptions.push(s1);
      }

      //code for check idle timeout
    var s2 =  this.idleTimeoutSvc.startWatching(1200).subscribe((res) => {

      if (res && this.router.url.indexOf('/login') < 0)  {

        this.logOut();
        console.log("log out");
        var now = new Date();
      console.log(now);
      }
    });
    this.subscriptions.push(s2);

  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  ngAfterContentChecked() {

    let user = this.userProfileService.data;
    if (user.DisplayName) {
      this.userDisplayName = user.DisplayName;
      this.customerName = user.CustomerName;
      this.customerSelect =  this.userProfileService.GetMappedCustomer(this.customerName);
      this.enabledProducts =  this.productRouteInfoService.Get(user.ProductAccess);

      this.enabledAdminAccess = [{text: 'Configuration', path:'admin/configuration'}];
      if(user.SSOPortalURL)
        this.homeURL = user.SSOPortalURL;
      if(user.RoleList.includes('Super User'))
        this.enabledAdminAccess.push({text: 'Manage Customers', path:'admin/accounts/manage-customers/user-list'});
      else if(user.RoleList.includes('Corporate Admin'))
        this.enabledAdminAccess.push({text: 'Manage Users', path:'admin/accounts/manage-users/user-list'});

      if(user.ProductAccess.length>0)
      {
        let start:dropdownMenuInfo[] = [{text: 'Notifications',  disabled: true}];
        this.reportsMapping = this.productRouteInfoService.GetReports(user.ProductAccess);
        this.enabledAdminAccess = this.enabledAdminAccess.concat(start.concat(
            this.reportsMapping.map(r => {return { text: r.text, path: r.path, indent: true};}))
          );
      }

      this.allowedToChangeCustomer = user.allowedCustomerList.length <=1?false:true;
      this.customerSelectionList = user.allowedCustomerList//.map(i => i.text)
        .sort((a, b) => {
          return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
        });
    }
  }

  public async logOut(){
    let portalUrl = this.userProfileService.data.SSOPortalURL;
    try {
      let okay = false;
      let rtn = this.loginService.logout().pipe(
        map(r => true))
        .toPromise();
      let xxs = await rtn;
      okay = xxs;
    } catch (error) {

    }
    this.userProfileService.UpdateUserState()
        // .finally(()=>{
        //   if(portalUrl){
        //     window.location.assign(portalUrl);
        // } } )
        .subscribe((r)=>this.router.navigate(['/login']).catch((reason)=> {console.log(reason)}).then(bb => console.log("logOut() to / "+ ( bb?"true":"false")))
        ,(err) =>this.router.navigate(['/login']).catch((reason)=> {console.log(reason)}).then(bb => console.log("logOut() to / "+ ( bb?"true":"false")))
        );

      return false;
    }

  public Click1(item:ProductData)
  {
    this.openBtnRateIntegrity = false;
  }
/*
  onToggle($event: Event) {
    $event.stopPropagation();
    this.openBtnRateIntegrity = true;
  }
*/
  OnCustomerChanged(value:{ text: string, value: number }){
    if(value){
      let found = this.userProfileService.GetMappedCustomerById(value.value);
      let custmerID: number = found.value;
      this.customerName = found.text;
      this.loginService.updateSessionSetCustomer(custmerID).pipe(
      tap(nxt => {
        this.userProfileService
          .UpdateUserState()
          .subscribe(b => {
            let current =  this.router.routerState.snapshot.url;
            if (current == "/main") {
              this.productRouteInfoService.NavigateToHighestPriorityProduct(this.userProfileService.data.ProductAccess,this.router);
            }
            else {
              this.router.navigateByUrl("/main");
            }

            return;

            // var nxt = this.productRouteInfoService.GetHighestPriorityProduct( this.userProfileService.data.ProductAccess);
            // if(nxt){
            //   this.productRouteInfoService.NavigateToHighestPriorityProduct(this.userProfileService.data.ProductAccess,this.router);
            // }
            //  else{
            //   // this.errors.push("None of the Rate Intergrity products has been activated, contact customer support ");
            //   this.router.navigate(['/main'])
            //  }
          }
          , error => {}//this.ShowError(error, "UpdateUserState")
          );
      }))
      .subscribe(b => {},err=>{});

    }
  }

}
